import { css } from "@emotion/react"
import { MobileMenu } from "@/templates/MobileMenu"
import { theme } from "@/theme"
import { MobileAppHeader } from "@/components/Header/MobileAppHeader"

/**
 * 清掃員向けページ共通のヘッダー（メニュー＋タイトル＋戻る）
 */
export const CleanerPageHeader = ({
    title,
    onPrev,
    children
}: {
    title: string
    onPrev?: () => void
    children?: React.ReactNode
}) => {
    return (
        <div
            css={css`
                position: sticky;
                top: 0;
                z-index: ${theme.zIndex.appBar};
                padding-top: env(safe-area-inset-top, 0px);
                background-color: ${
                    theme.palette.intentions.cleanerBackground.main
                };
            `}
        >
            <div
                css={css`
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    background-color: ${
                        theme.palette.intentions.cleanerBackground.main
                    };
                `}
            >
                <MobileMenu />
            </div>
            <MobileAppHeader
                css={css`
                    background-color: ${
                        theme.palette.intentions.cleanerBackground.main
                    };
                `}
                title={<h3>{title}</h3>}
                onPrev={onPrev}
            >
                {children ?? null}
            </MobileAppHeader>
        </div>
    )
}
